import Spline from '@splinetool/react-spline';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  position:relative;
  width:100%;
  height:100%; 
  overflow-x: hidden;
  .spline{
    position: absolute;
    margin:0;
    top:o;
    right:0;
  }

`

export default function Animation() {
  return (
    <Wrapper>
      {/* <Spline scene="https://prod.spline.design/58tK0Tc1yFfFXfv3/scene.splinecode" /> */}
      <Spline scene="https://prod.spline.design/58tK0Tc1yFfFXfv3/scene.splinecode"/>
    
    </Wrapper>
  );
}
